module.exports = __webpack_public_path__ + "img/logo-white-2.489b02b0.svg";